import Flex from '@Styles/flex.scss';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import TextInput from '@Components/DomElements/TextInput';
import { ModalFooter } from '@Components/ModalComponents';
import DepartmentsApi from '@Data/departments/Api';
import { error } from '@Services/notification/NotificationServices';
import Styles from './ConnectDept.scss';

interface IIkeOfficeLoginStepProps {
    setFooter: (footer: JSX.Element) => void;
    onCancel: () => void;
    onLoggedIn: () => void;
    setCancelDisabled: (disabled: boolean) => void;
}

export const IkeOfficeLoginStep = (props: IIkeOfficeLoginStepProps) => {
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const canSubmit = username.length > 0 && password.length > 0;

    const handleEnterSubmit = (e) => {
        if (e.key === 'Enter' && canSubmit) {
            handleLogin();
        }
    };

    const handleLogin = async () => {
        setIsSubmitting(true);
        props.setCancelDisabled(true);
        const wasLoginSuccessful = await DepartmentsApi.getDepartments(
            username,
            password
        );
        setIsSubmitting(false);
        props.setCancelDisabled(false);
        if (!wasLoginSuccessful) {
            error('Your IKE Office username or password was incorrect.');
        } else {
            props.onLoggedIn();
        }
    };

    const inputStyle = {
        width: '100%',
    };

    useEffect(() => {
        props.setFooter(
            <ModalFooter
                id="ike-login-footer"
                onCancel={props.onCancel}
                onSubmit={handleLogin}
                canSubmit={canSubmit}
                submitText="Login"
                isSubmitting={isSubmitting}
            />
        );
    }, [username, password, canSubmit, isSubmitting]);

    return (
        <div
            id="ike-login-container"
            className={cx(Flex.flex, Flex.column, Flex.alignItemsCenter)}
        >
            <div className={Styles.loginContainer}>
                <span className={Styles.loginTitle}>
                    Please enter your IKE Office credentials
                </span>
                <TextInput
                    id="ike-username-input"
                    onChange={(e) => {
                        setUsername(e.target.value);
                    }}
                    onKeyDown={(e) => {
                        handleEnterSubmit(e);
                    }}
                    value={username}
                    label="Username"
                    autoFocus
                    inputStyle={inputStyle}
                    containerStyle={{ marginBottom: '23px', width: '100%' }}
                />

                <TextInput
                    id="ike-password-input"
                    onChange={(e) => {
                        setPassword(e.target.value);
                    }}
                    onKeyDown={(e) => {
                        handleEnterSubmit(e);
                    }}
                    value={password}
                    label="Password"
                    type="password"
                    inputStyle={inputStyle}
                    containerStyle={{ width: '100%' }}
                />
            </div>
        </div>
    );
};
